import { Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { ChevronRightIconComponent } from '../../../../@icons/chevron-right.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'vw-extendable-card',
  imports: [ChevronRightIconComponent, CommonModule],
  templateUrl: './extendable-card.component.html',
  styleUrl: './extendable-card.component.scss'
})
export class ExtendableCardComponent {
  @Input() isExpandable: boolean = true;
  @Input() isExpanded: boolean = false;

  @Input() iconColor: string = '#317756';

  @Input() headerTemplate: TemplateRef<any> | null;
  @Input() bodyTemplate: TemplateRef<any> | null;

  @Output() toggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('content') content: ElementRef;

  toggleCard() {
    this.isExpanded = !this.isExpanded;
    this.toggle.emit(this.isExpanded);
  }
}
